"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDistanceResultDto = instanceOfDistanceResultDto;
exports.DistanceResultDtoFromJSON = DistanceResultDtoFromJSON;
exports.DistanceResultDtoFromJSONTyped = DistanceResultDtoFromJSONTyped;
exports.DistanceResultDtoToJSON = DistanceResultDtoToJSON;
exports.DistanceResultDtoToJSONTyped = DistanceResultDtoToJSONTyped;
/**
 * Check if a given object implements the DistanceResultDto interface.
 */
function instanceOfDistanceResultDto(value) {
    if (!('originId' in value) || value['originId'] === undefined)
        return false;
    if (!('destinationId' in value) || value['destinationId'] === undefined)
        return false;
    if (!('distanceMiles' in value) || value['distanceMiles'] === undefined)
        return false;
    return true;
}
function DistanceResultDtoFromJSON(json) {
    return DistanceResultDtoFromJSONTyped(json, false);
}
function DistanceResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'originId': json['originId'],
        'destinationId': json['destinationId'],
        'distanceMiles': json['distanceMiles'],
    };
}
function DistanceResultDtoToJSON(json) {
    return DistanceResultDtoToJSONTyped(json, false);
}
function DistanceResultDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'originId': value['originId'],
        'destinationId': value['destinationId'],
        'distanceMiles': value['distanceMiles'],
    };
}
//# sourceMappingURL=DistanceResultDto.js.map